/* Isolated editorial enhancements. No modification of prices, proof, discounts or cart. */
(() => {
  const mounted=new WeakSet();
  function init(scope=document){
    scope.querySelectorAll('[data-eo-guide]').forEach(root=>{
      if(mounted.has(root))return;
      const tabs=[...root.querySelectorAll('[data-eo-tab]')];
      const panels=[...root.querySelectorAll('[data-eo-panel]')];
      const select=tab=>{tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});panels.forEach(p=>{p.hidden=p.dataset.eoPanel!==tab.dataset.eoTab;p.setAttribute('role','tabpanel');p.setAttribute('aria-labelledby',tabs.find(t=>t.dataset.eoTab===p.dataset.eoPanel).id);});};
      tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();select(tabs[n]);tabs[n].focus();}});});
      root.querySelector('[data-eo-guide-controls]').hidden=false;select(tabs[0]);mounted.add(root);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
